module.exports = __webpack_public_path__ + "media/images/icon__minus-4a71c7552455e1fa91b14ec62efd88ee.png";